import yup from 'yup';
import find from 'lodash/find';
import get from 'lodash/get';
import styled from '@emotion/styled';

import Text from '@lightspeed/cirrus-text';
import { color, spacing, fontWeight } from '@lightspeed/cirrus-tokens/utils';

import { TERMINAL_TYPE } from 'shared_modules/Terminals';
import { GatewayType } from 'pages/store/selectors/gatewayConfig';

const GatewayTerminalMapping = {
  BLACKLINE: 'dejavoo-z9-blackline',
  CAYAN: 'verifone-mx-915-genius',
  TRI_POS: 'verifone-mx-915-tripos',
  LS_PAYMENTS: 'verifone-mx-915-lightspeed',
  TYRO: 'yomani',
  NO_TERMINAL_SUPPORT: 'no-terminal-support',
};

export const getTerminalParamsByGatewayID = (gatewayID, terminalParameters) => {
  let terminalType;
  switch (gatewayID) {
    case GatewayType.CAYAN:
      terminalType = GatewayTerminalMapping.CAYAN;
      break;

    case GatewayType.MERCURY_EMV:
    case GatewayType.VANTIV_US:
    case GatewayType.VANTIV_CANADA:
      terminalType = GatewayTerminalMapping.BLACKLINE;
      break;

    case GatewayType.VANTIV_TRIPOS:
      terminalType = GatewayTerminalMapping.TRI_POS;
      break;

    case GatewayType.LIGHTSPEED_PAYMENTS:
      terminalType = GatewayTerminalMapping.LS_PAYMENTS;
      break;

    case GatewayType.TYRO:
      terminalType = GatewayTerminalMapping.TYRO;
      break;

    default:
      terminalType = GatewayTerminalMapping.NO_TERMINAL_SUPPORT;
      break;
  }

  return get(
    find(terminalParameters, terminal => terminal.terminalID === terminalType),
    'parameters.parameter',
    []
  );
};

export const getTerminalTypeByGatewayID = gatewayID => {
  let terminalType;
  switch (gatewayID) {
    case GatewayType.CAYAN:
      terminalType = TERMINAL_TYPE.GENIUS;
      break;

    case GatewayType.MERCURY_EMV:
    case GatewayType.VANTIV_US:
    case GatewayType.VANTIV_CANADA:
      terminalType = TERMINAL_TYPE.BLACKLINE;
      break;

    case GatewayType.VANTIV_TRIPOS:
      terminalType = TERMINAL_TYPE.TRIPOS;
      break;

    case GatewayType.LIGHTSPEED_PAYMENTS:
      terminalType = TERMINAL_TYPE.LIGHTSPEED;
      break;

    case GatewayType.TYRO:
      terminalType = TERMINAL_TYPE.YOMANI;
      break;

    default:
      terminalType = TERMINAL_TYPE.UNKNOWN;
      break;
  }

  return terminalType;
};

const PARAMETER_VALIDATION = {
  name: yup.string().max(50, 'The name may not be greater than 50 characters.'),
  serialNumber: yup.string().required('Serial Number is required'),
  activationCode: yup.string().required('Activation Code is required'),
  address: yup.string().required('IP Address is required'),
};

export const generateValidationSchema = parameters => {
  const schema = {};

  parameters.forEach(parameter => {
    if (PARAMETER_VALIDATION[parameter.id]) {
      schema[parameter.id] = PARAMETER_VALIDATION[parameter.id];
    }
  });

  return yup.object().shape({
    ...schema,
  });
};

export const BusyActionState = styled(Text)`
  margin-left: ${spacing(1)};
  color: ${color('blue')};
`;

export const CompletedActionState = styled(Text)`
  margin-left: ${spacing(1)};
  font-weight: ${fontWeight('bold')};
`;
